
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CognitoUtil } from '../services/cognito.service'
import { UserLoginService } from '../services/user-login.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(public router: Router, public cognitoUtil: CognitoUtil, public userLoginService: UserLoginService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const isAuthenticated = this.userLoginService.isLoggedIn(this.cognitoUtil)
    if (!isAuthenticated) {
      if (this.isSimpleRedirectSupported(state.url)) {
        return this.router.createUrlTree(["/public/login"], { queryParams: { redirect: state.url } });
      } else {
        return this.router.createUrlTree(["/public/login"], { queryParams: route.queryParams });
      }
    }

    return isAuthenticated;
  }

  canActivateChild(router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(router, state);
  }

  isSimpleRedirectSupported(url: string) {
    return url ? ["leases/non-legacy-leases-dashboard"].some(u => url.includes(u)) : false
  }

}
